import type { User } from '@/entities/user/types/user';

export function getUserRoles(user: Pick<User, 'role' | 'roles'>) {
  const roles = [...(user.roles ?? []), ...(user.role ? [user.role] : [])]
    .map(role => role?.trim())
    .filter((role): role is string => Boolean(role));

  return [...new Set(roles)];
}

export function hasUserRole(user: Pick<User, 'role' | 'roles'>, roleName: string) {
  return getUserRoles(user).some(role => role.toLowerCase() === roleName.toLowerCase());
}

export function getPrimaryUserRole(user: Pick<User, 'role' | 'roles'>) {
  return getUserRoles(user)[0] ?? null;
}
